import { CreateActivityDialog } from '../components/CreateActivityDialog';
import type {
  ActivityCreationGateway,
  ActivityCreationJourney,
} from './contracts';

export interface ActivityCreationSurfaceProps {
  journey: ActivityCreationJourney;
  gateway: ActivityCreationGateway;
  open?: boolean;
  onClose: () => void;
  onCreated?: () => void;
}

export const ActivityCreationSurface = ({
  journey,
  gateway,
  open = true,
  onClose,
  onCreated,
}: ActivityCreationSurfaceProps) => (
  <CreateActivityDialog
    open={open}
    onClose={onClose}
    onCreated={onCreated}
    journey={journey}
    gateway={gateway}
  />
);
